import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { LiveReportList } from '@futrli-sdk/predict';

import { ExportReportWizardContainer } from './export-report-wizard-container';


interface ExportReportSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  report: LiveReportList;
}

export const ExportReportSidebar = ({ isOpen, onClose, report }: ExportReportSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="reporting.export_report_to_pdf" defaultMessage="Export report to PDF" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <ExportReportWizardContainer onClose={onClose} report={report} />
  </Sidebar>
);
